import client from './client';

export const claimJob = (id, period) => client.post('/sync-jobs/claim', { id, period }).then((r) => r.data);
export const doneJob = (id, period) => client.post('/sync-jobs/done', { id, period }).then((r) => r.data);
export const releaseJob = (id, period) => client.post('/sync-jobs/release', { id, period }).then((r) => r.data);
export const requestSyncHelp = () => client.post('/sync-jobs/help').then((r) => r.data);
export const getSyncHelp = () => client.get('/sync-jobs/help').then((r) => r.data);
